export const timeSlots = [
    { value: '17', label: '08:00:00 AM - 08:30:00 AM' },
    { value: '18', label: '08:30:00 AM - 09:00:00 AM' },
    { value: '19', label: '09:00:00 AM - 09:30:00 AM' },
    { value: '20', label: '09:30:00 AM - 10:00:00 AM' },
    { value: '21', label: '10:00:00 AM - 10:30:00 AM' },
    { value: '22', label: '10:30:00 AM - 11:00:00 AM' },
    { value: '23', label: '11:00:00 AM - 11:30:00 AM' },
    { value: '24', label: '11:30:00 AM - 12:00:00 PM' },
    { value: '25', label: '12:00:00 PM - 12:30:00 PM' },
    { value: '26', label: '12:30:00 PM - 01:00:00 PM' },
    { value: '27', label: '01:00:00 PM - 01:30:00 PM' },
    { value: '28', label: '01:30:00 PM - 02:00:00 PM' },
    { value: '29', label: '02:00:00 PM - 02:30:00 PM' },
    { value: '30', label: '02:30:00 PM - 03:00:00 PM' },
    { value: '31', label: '03:00:00 PM - 03:30:00 PM' },
    { value: '32', label: '03:30:00 PM - 04:00:00 PM' },
    { value: '33', label: '04:00:00 PM - 04:30:00 PM' },
    { value: '34', label: '04:30:00 PM - 05:00:00 PM' },
    { value: '35', label: '05:00:00 PM - 05:30:00 PM' },
    { value: '36', label: '05:30:00 PM - 06:00:00 PM' },
    { value: '37', label: '06:00:00 PM - 06:30:00 PM' },
    { value: '38', label: '06:30:00 PM - 07:00:00 PM' },
    { value: '39', label: '07:00:00 PM - 07:30:00 PM' },
    { value: '40', label: '07:30:00 PM - 08:00:00 PM' },
    { value: '41', label: '08:00:00 PM - 08:30:00 PM' },
    { value: '42', label: '08:30:00 PM - 09:00:00 PM' },
    { value: '43', label: '09:00:00 PM - 09:30:00 PM' },
    { value: '44', label: '09:30:00 PM - 10:00:00 PM' },
    { value: '45', label: '10:00:00 PM - 10:30:00 PM' },
];

export const getSlotName = (slotId) => {
    const numericSlotId = parseInt(slotId, 10);

    if (numericSlotId >= 25 && numericSlotId <= 32) {
        return 'Afternoon';
    }

    if (numericSlotId >= 33) {
        return 'Evening';
    }

    return 'Morning';
};
